import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import scrollReveal from "@scripts/components/scroll-reveal";
import { isTouchDevice } from "@common/util";
import hoverIntent from "@common/hover-intent";

gsap.registerPlugin(ScrollTrigger);

const setupBusinessUnitBlocks = () => {
  const blockGrid = document.querySelector(".business-unit-blocks");

  document.querySelectorAll(".business-unit-block").forEach((block) => {
    const blockInner = block.querySelector(".business-unit-block-inner");
    const otherBlocks = Array.from(blockGrid.querySelectorAll(".business-unit-block")).filter((x) => x !== block);
    const shortDescription = block.querySelector(".business-unit-short");
    const longDescription = block.querySelector(".business-unit-long");

    const enterTimeline = gsap.timeline({
      paused: true,
    });

    enterTimeline
      .to(blockGrid, {
        width: blockGrid.offsetWidth,
        height: blockGrid.offsetHeight,
      })
      .to(otherBlocks, { pointerEvents: "none" }, "<")
      .to(block, { zIndex: 2 }, "<")
      .to(
        otherBlocks,
        {
          opacity: 0.3,
          duration: 0.2,
        },
        "<",
      )
      .to(
        shortDescription,
        {
          opacity: 0,
          y: "10%",
          duration: 0.3,
          onComplete: () => {
            shortDescription.classList.add("sr-only");
          },
          onReverseComplete: () => {
            shortDescription.classList.remove("sr-only");
          },
        },
        "<",
      )
      .to(
        blockInner,
        {
          width: blockGrid.offsetWidth * 0.95,
          height: blockGrid.offsetHeight * 0.95,
          top: () => {
            const blockGridRect = blockGrid.getBoundingClientRect();
            const blockRect = blockInner.getBoundingClientRect();

            if (blockRect.top > blockGridRect.top) {
              return "-100%";
            }

            return 0;
          },
          left: () => {
            const blockGridRect = blockGrid.getBoundingClientRect();
            const blockRect = blockInner.getBoundingClientRect();

            if (blockRect.left > blockGridRect.left) {
              return "-95%";
            }

            return 0;
          },
          duration: 0.3,
        },
        "<25%",
      )
      .fromTo(
        longDescription,
        { visibility: "invisible", opacity: 0, y: "50%" },
        { visibility: "visible", opacity: 1, y: 0, duration: 0.3 },
      );

    new hoverIntent([block], {
      onEnter: () => {
        if (block.querySelector("[data-sr-done]")) {
          enterTimeline.play();
          block.classList.add("is-active");
        }
      },
      onExit: async () => {
        if (block.querySelector("[data-sr-done]")) {
          block.style.pointerEvents = "none";
          await enterTimeline.reverse();
          block.style.pointerEvents = "auto";
          block.classList.remove("is-active");
        }
      },
      exitDelay: 100,
      interval: 100,
      sensitivity: 7,
    });
  });
};

const setupContentMedia = () => {
  const element = document.querySelector(".element-contentmedia");

  if (!element) {
    return;
  }

  const brandLogo = element.querySelector(".brand-logo svg");
  const brandLogoRect = brandLogo.getBoundingClientRect();
  const panelRect = element.getBoundingClientRect();
  const panelCenterX = panelRect.width / 2;
  const panelCenterY = panelRect.top + panelRect.height / 2;

  const scaleFactor = panelRect.height / brandLogoRect.height;

  const offsetX = panelCenterX - (brandLogoRect.left + brandLogoRect.width / 2);
  const offsetY = panelCenterY - (brandLogoRect.top + brandLogoRect.height / 2);

  gsap.set(brandLogo, {
    transformOrigin: "center center",
    transform: `translate(${offsetX}px, ${offsetY}px) scale(${scaleFactor})`,
  });

  const timeline = gsap.timeline({
    paused: true,
    onComplete: () => {
      scrollReveal.reveal(element.querySelector("[data-sr-group]"));
    },
    scrollTrigger: {
      trigger: element,
      start: "top 40%",
      once: true,
      markers: false,
    },
  });

  timeline.to(brandLogo, {
    transform: "scale(1) translate(0, 0)",
    duration: 0.5,
  });
};

if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  if (window.matchMedia("(min-width: 1024px)").matches && !isTouchDevice) {
    setTimeout(setupBusinessUnitBlocks, 500);
  }
}

if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  setupContentMedia();
}
